import {useEffect, useContext, useState} from "react";
import Step from "./Step";
import Dollars from "../Dollars";
import EditPayee from "../EditPayee";
import RefreshContext from "../../RefreshContext";

export default function FixAPayee({index}) {
  const [payees, setPayees] = useState(null);
  const [canProceed, setCanProceed] = useState(false);
  const [editPayee, setEditPayee] = useState(null);

  // when a payee is edited or deleted, we should refetch the payees.
  const {refreshKey} = useContext(RefreshContext);

  useEffect(() => {
    fetch("/api/on_ramp/top_payees")
      .then(response => response.json())
      .then(data => {
        setPayees(data);
      })
      .catch(console.error);
  }, [refreshKey]);

  function editPayeeDone() {
    setEditPayee(null);
    setCanProceed(true);
  }
  if (!payees) return "";

  return <Step index={index}
               title="Fix a Payee"
               busyReason={"Cick on a Payee to edit it."}
               canProceed={canProceed}
               isFinal>
    <p>
      Sometimes we miscategorize a transaction. For example, we may categorize a transfer
      between two of your accounts as spending. Or we may categorize a payment to a credit
      card as spending. You can fix this by changing or even deleting a the Payee.
    </p>
    <p>
      Usually the Payees with the largest spending totals are the most suspicious. are your
      top Payees by dollar volume:
    </p>
    <table className={"table table-sm table-striped table-hover"}>
      <thead>
      <tr>
        <th>Payee</th>
        <th>Category</th>
        <th>Count</th>
        <th className={"text-end"}>Total</th>
      </tr>
      </thead>
      <tbody>
      {payees.map((payee, i) => (
        <tr key={i} onClick={() => setEditPayee(payee)}>
          <td>{payee.name}</td>
          <td>{payee.category}</td>
          <td>{payee.transaction_count}</td>
          <td className={"text-end"}>
            <Dollars amount={payee.total_amount}/>
          </td>
        </tr>
      ))}
      </tbody>
    </table>
    <p>
      Following are common reasons why a payee might be miscategorized:
    </p>
    <ul>
      <li>
        A payee is really an internal transfer that we haven't recognized (for example paying off a credit
        card). In this case, you should mark the payee as an internal transfer and its
        matching transactions will be skipped when performing spend analysis.
      </li>
      <li>
        A payee's match expression isn's specific enough and is matching too many transactions.
        In this case, you should edit the payee's match expression to be more specific.
      </li>
      <li>
        The payee shouldn't exist at all. Sometimes we accidentally create a payee like
        "Transfer" or "Payment" that shouldn't exist. In this case, you should delete the payee.
        We will attempt to re-categorize the transactions that were assigned to this payee.
      </li>
      <li>
        The Payee belongs to an incorrect category. We might for example categorize
        "Amazon.com" as "Groceries" when it should be "Shopping". In this case, you should
        change the category of the payee.
      </li>
    </ul>
    {editPayee && <EditPayee payee={editPayee} onHide={editPayeeDone} />}
  </Step>

}